import $ from 'jquery';
// import Instafeed from 'instafeed.js';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
// import FetchSourceImages from './FetchSourceImages';
import SelectList from './SelectList';
import SelectBox from './SelectBox';
import Columns from './Columns';
import MenuActive from './MenuActive';
import AccordionFix from './AccordionFix';
import AccordionWrap from './AccordionWrap';
import AccordionContainer from './AccordionContainer';
import Placeholder from './Placeholder';
import Video from './Video';
import Banner from './Banner';
import PlayPauseControls from './PlayPauseControls';
import BackgroundImage from './BackgroundImage';
import StringSplit from './StringSplit';
// import SliderEvents from './Slider.Events';
import RemoveLink from './RemoveLink';
// import Marauders from './Marauders';
import CalendarGridFilters from './CalendarGridFilters';
// import NextSlide from './NextSlide';
import RelatedProfilesAlt from './RelatedProfilesAlt';
import BrowserCheck from './BrowserCheck';
import NewNews from './NewNews';
import SliderSchools from './Slider.Schools';

// Add the theme behaviors
Drupal.behavior((context) => {
  // eslint-disable-next-line no-new
  // new FetchSourceImages(context);

  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Get browser and version
  $body.each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });
  $('.toolbar', context).each((i, element) => {
    if (!element.menuActive) {
      element.menuActive = new MenuActive(element, {
        selector: 'button',
      });
    }
  });

  // Convert secondary menu into columns
  // $('#block-nice_menus-3 ul.depth-2', context).each((i, element) => {
  //   if (!element.columns) {
  //     element.columns = new Columns(element, {
  //       columns: 4,
  //       item: 'li.depth-2',
  //       blockName: 'menu-navigation',
  //     });
  //   }
  // });
  $('.footerlinks', context).each((i, element) => {
    if (!element.columns) {
      element.columns = new Columns(element, {
        columns: 2,
        item: '.views-row',
        parent: '.view-content',
        divider: 'new-col',
        blockName: 'footerlinks',
      });
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
      $(element).addClass('ready');
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  $('.node-content', context).each((i, element) => {
    if (!element.accordionContainer) {
      element.accordionContainer = new AccordionContainer(element);
    }
  });

  // Set placeholder of textfield using label
  $('.pods .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element, {
        trim: true,
      });
    }
  });

  // Hero Video
  $('.front .page-top', context).each((i, element) => {
    if (!element.video) {
      element.video = new Video(element);
      element.video = new PlayPauseControls(element);
    }
  });

  // Adds .has-banner class to body if banner exists
  $('.page-top .block', context).each((i, element) => {
    if (!element.banner) {
      element.banner = new Banner(element);
    }
  });

  // Background image
  $('.has-banner .page-top', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
    }
  });

  $('.home-choose-jesuit .field-video a', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        sourceSelector: 'img',
      });
    }
  });

  $('.home-marauders-images .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        sourceSelector: 'img',
      });
    }
  });

  // Select list generator
  let selectIdentifier = 1;
  $('.headerlinks-dropdowns .views-row', context).each((i, element) => {
    // Creates a select box from all of the related links.
    if (!element.selectList) {
      element.selectList = new SelectList(element, {
        numerator: selectIdentifier,
      });
      element.selectBox = new SelectBox(element);
      selectIdentifier += 1;
    }
  });
  $('#block-views_blocks-term-block_1-7', context).each((i, element) => {
    if (!element.headerlinks) {
      element.headerlinks = new SelectList(element, {
        numerator: selectIdentifier,
        destination: '.view',
        placeholder: 'I am a...',
        optionSrc: '.node-header',
      });
      selectIdentifier += 1;
    }
  });

  // Split text at verticle pipe
  $('.home-stat', context).each((i, element) => {
    if (!element.stringSplit) {
      element.stringSplit = new StringSplit(element, {
        title: '.subtitle',
      });
    }
  });
  $('.home-choose-jesuit', context).each((i, element) => {
    if (!element.stringSplit) {
      element.stringSplit = new StringSplit(element, {
        title: '.block-title-text',
        divider: '|',
      });
    }
  });

  // Home Events Slider
  // $('.home-events', context).each((i, element) => {
  //   if (!element.sliderEvents) {
  //     element.sliderEvents = new SliderEvents(element);
  //     element.nextSlide = new NextSlide(element);
  //   }
  // });

  // Remove link from node header
  $('.home-marauaders-header', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });

  // Hear From Our Marauders image handling
  // $('.front .page-bottom', context).each((i, element) => {
  //   if (!element.marauders) {
  //     element.marauders = new Marauders(element);
  //   }
  // });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element, {
        useFilters: true,
        filters: {
          All: 60,
          Admissions: 793,
          Advancement: 794,
          Alumni: 851,
          Arts: 795,
          Athletics: 792,
          Counseling: 827,
          Ministry: 916,
          Parents: 853,
          'Schedule Rotation': 446,
          Social: 913,
          Student: 849,
          Video: 106,
        },
      });
    }
  });

  // Calendar of Events Grid View Filters
  $('.view-grid-calendar', context).each((i, element) => {
    if (!element.calendarGridFilters) {
      element.calendarGridFilters = new CalendarGridFilters(element, {
        filters: {
          All: 60,
          Admissions: 793,
          Advancement: 794,
          Alumni: 851,
          Arts: 795,
          Athletics: 792,
          Counseling: 827,
          Ministry: 916,
          Parents: 853,
          'Schedule Rotation': 446,
          Social: 913,
          Student: 849,
          Video: 106,
        },
      });
    }
  });

  // Homepage: Instagram Slider
  $('#instagram-slider', context).each((i, element) => {
    if (!$(element).hasClass('ready') && !$(element).closest('.block').hasClass('block-instagram-feed')) {
      $(element).addClass('ready');
      $(element).closest('.block').addClass('block-instagram-feed');
    }
  });

  // Replace block title in related contacts
  $('#block-digitaldcore-node_contacts', context).each((i, element) => {
    if (!element.relatedProfileAlt) {
      element.relatedProfileAlt = new RelatedProfilesAlt(element, {
        block_title: 'Moderator',
        applyTo: [
          '683', // Heritage / International Club
          '684', // Special Interest Club
          '685', // Academic Club
          '686', // Service Club
          '777', // Theming Scaffold for testing
          // If you add to this array, don't forget to add the class to page-right.less
        ],
      });
    }
  });

  // New news
  $('.new-news', context).each((i, element) => {
    if (!element.newNews) {
      element.newNews = new NewNews(element);
    }
  });

  // Schools Slider
  $('.schools-slider', context).each((i, element) => {
    if (!element.sliderSchools) {
      element.sliderSchools = new SliderSchools(element);
    }
  });

  // Move elements on home page
  const contentBeforeLeft = document.querySelector('.content-before-wrapper .content-before-left');
  const contentBeforeRight = document.querySelector('.content-before-wrapper .content-before-right');

  const homeEventsTitle = document.querySelector('.home-events-header');
  const homeEvents = document.querySelector('.home-events');
  const homeAlumniTitle = document.querySelector('.home-marauders-header');
  const homeAlumniStories = document.querySelector('.home-marauders-images');

  if (homeEvents && homeEventsTitle) {
    contentBeforeLeft.prepend(homeEvents);
    contentBeforeLeft.prepend(homeEventsTitle);
  }
  if (homeAlumniStories && homeEventsTitle) {
    contentBeforeRight.prepend(homeAlumniStories);
    contentBeforeRight.prepend(homeAlumniTitle);
  }

  // Calendar List Home: move time from date to bottom
  function homeCalDate() {
    const nodeTeaser = document.querySelectorAll('#block-views_blocks-term-block_1-11 .node-teaser .node-inner');
    nodeTeaser.forEach((e) => {
      const eventDates = e.querySelector('.date-display-single');
      const eventDateInner = eventDates.innerHTML;
      const nodeHeader = e.querySelector('.node-header');
      nodeHeader.insertAdjacentHTML('afterend', `<div class="meta-datetime">${eventDateInner.substring(eventDateInner.indexOf('- ') + 1)}</div>`);
      eventDates.innerHTML = eventDateInner.substring(0, eventDateInner.indexOf('-'));
    });
  }
  window.addEventListener('load', homeCalDate);

  // Whats new section: node-content height same as node-image height
  // const nodeNews = document.querySelectorAll('body.front .new-news .slick-track .slick-slide .has-image .node-inner');
  // console.log(nodeNews);

  // nodeNews.forEach((e) => {
  //   const nContent = e.querySelector('.node-content');
  //   const nImage = e.querySelector('.node-image');
  // });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});
